import React from "react";
import Duties  from "../modules/Duties/Duties";
export default function DutiesPage() {
  return <Duties />;
}
